import { render, staticRenderFns } from "./materialRegist.vue?vue&type=template&id=b16dc830&scoped=true&"
import script from "./materialRegist.vue?vue&type=script&lang=js&"
export * from "./materialRegist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16dc830",
  null
  
)

export default component.exports